import { Check, ShieldCheck } from 'lucide-react';
import { Typography } from './Typography';
import { SectionHeading } from './SectionHeading';
import { Wordmark } from './Wordmark';
import { company, principles } from '../content/site';
import styles from './CredentialsSection.module.css';
export function CredentialsSection() {
  return (
    <section className={styles.section} id="about">
      <div className={styles.copy}>
        <SectionHeading
          eyebrow="Почему Audit Vector"
          title="Независимость, подтверждённая статусом"
          align="start"
          description="Проверка должна давать уверенность. Мы опираемся на стандарты учёта, нормативную базу и прозрачные процедуры."
        />
      </div>
      <div className={styles.cards}>
        <article className={styles.license}>
          <ShieldCheck size={32} strokeWidth={1.2} aria-hidden />
          <Typography as="h3" variant="cardTitle">
            Государственная лицензия
          </Typography>
          <Typography variant="quote">{company.license}</Typography>
          <Typography variant="small" tone="muted">{`Выдана ${company.licenseDate}`}</Typography>
          <div className={styles.rows}>
            <Typography variant="small" tone="muted">
              КК МФ РК
            </Typography>
            <Typography
              variant="small"
              tone="muted"
            >{`Регистрация: ${company.registration}`}</Typography>
            <Typography
              variant="small"
              tone="muted"
            >{`Свидетельство СА РК ${company.certificate}`}</Typography>
          </div>
        </article>
        <article className={styles.values}>
          <Wordmark inverse linked={false} />
          <div className={styles.valueList}>
            {principles.map((x) => (
              <div key={x.n}>
                <Check size={18} aria-hidden />
                <div>
                  <Typography variant="body" tone="inverse">
                    {x.t}
                  </Typography>
                  <Typography variant="caption" tone="inherit">
                    {x.d}
                  </Typography>
                </div>
              </div>
            ))}
          </div>
        </article>
      </div>
    </section>
  );
}
